import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { sortBy, reverse, take } from 'lodash'
import { InfoCircleOutlined, DownloadOutlined, PlusOutlined, MinusOutlined, CheckCircleOutlined, ClockCircleOutlined, EyeOutlined, LoadingOutlined, FileTextOutlined, FilePdfOutlined } from '@ant-design/icons';
import { Table, Popover, Button, Tooltip, Tag, Spin, message } from 'antd';
import ServiceTypeIcons from '../../../../Components/ServiceTypeIcons';
import { getRamsSignedRecords, downloadRamsSignOffSheet, downloadRamsRevisionSheet, downloadRamsFullWithSignOff } from '../../../../HttpRequests/ramsControlCentre';
import styles from "./Component.css";

export default class _RamsRecords_ extends React.PureComponent {

  static propTypes = {
    project: PropTypes.object.isRequired,
    fetching: PropTypes.bool.isRequired,
    componentWillMount: PropTypes.func.isRequired,
    onClickRecord: PropTypes.func.isRequired,
    onClickNew: PropTypes.func.isRequired,
  }

  state = {
    expandedRowKeys: [],
    signedRecords: {},
    loadingRecords: {},
    downloadingSignOff: {},
    downloadingRevision: {},
    downloadingFull: {},
  }

  componentWillMount = () => this.props.componentWillMount()

  handleDownloadSignOff = (ramsRecordId) => {
    var self = this
    self.setState(function (prev) {
      var s = Object.assign({}, prev.downloadingSignOff)
      s[ramsRecordId] = true
      return { downloadingSignOff: s }
    })
    downloadRamsSignOffSheet(ramsRecordId).then(function (response) {
      if (response.data && response.data.download_url) {
        window.open(response.data.download_url, '_blank')
      }
    }).catch(function (err) {
      var msg = err.response && err.response.data && err.response.data.error
        ? err.response.data.error
        : 'Sign-off sheet not yet available'
      message.error(msg)
    }).then(function () {
      self.setState(function (prev) {
        var s = Object.assign({}, prev.downloadingSignOff)
        s[ramsRecordId] = false
        return { downloadingSignOff: s }
      })
    })
  }

  handleDownloadRevision = (ramsRecordId) => {
    var self = this
    self.setState(function (prev) {
      var s = Object.assign({}, prev.downloadingRevision)
      s[ramsRecordId] = true
      return { downloadingRevision: s }
    })
    downloadRamsRevisionSheet(ramsRecordId).then(function (response) {
      var blob = new Blob([response.data], { type: 'application/pdf' })
      var url = window.URL.createObjectURL(blob)
      var link = document.createElement('a')
      link.href = url
      link.download = 'RAMS_Revisions_' + ramsRecordId + '_' + moment().format('YYYY-MM-DD') + '.pdf'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }).catch(function (err) {
      var msg = err.response && err.response.data && err.response.data.error
        ? err.response.data.error
        : 'Could not generate revision sheet'
      message.error(msg)
    }).then(function () {
      self.setState(function (prev) {
        var s = Object.assign({}, prev.downloadingRevision)
        s[ramsRecordId] = false
        return { downloadingRevision: s }
      })
    })
  }

  handleDownloadFull = (ramsRecordId) => {
    var self = this
    self.setState(function (prev) {
      var s = Object.assign({}, prev.downloadingFull)
      s[ramsRecordId] = true
      return { downloadingFull: s }
    })
    downloadRamsFullWithSignOff(ramsRecordId).then(function (response) {
      var blob = new Blob([response.data], { type: 'application/pdf' })
      var url = window.URL.createObjectURL(blob)
      var link = document.createElement('a')
      link.href = url
      link.download = 'RAMS_Full_' + ramsRecordId + '_' + moment().format('YYYY-MM-DD') + '.pdf'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }).catch(function (err) {
      var msg = err.response && err.response.data && err.response.data.error
        ? err.response.data.error
        : 'Could not generate combined PDF'
      message.error(msg)
    }).then(function () {
      self.setState(function (prev) {
        var s = Object.assign({}, prev.downloadingFull)
        s[ramsRecordId] = false
        return { downloadingFull: s }
      })
    })
  }

  handleExpand = (recordId) => {
    var self = this
    var expandedRowKeys = this.state.expandedRowKeys
    var isExpanded = expandedRowKeys.indexOf(recordId) !== -1

    if (isExpanded) {
      this.setState({
        expandedRowKeys: expandedRowKeys.filter(function(k) { return k !== recordId })
      })
      return
    }

    this.setState({
      expandedRowKeys: expandedRowKeys.concat([recordId]),
      loadingRecords: Object.assign({}, this.state.loadingRecords, { [recordId]: true })
    })

    getRamsSignedRecords(recordId).then(function(response) {
      var rows = (response.data && response.data.rows) || []
      var newSignedRecords = Object.assign({}, self.state.signedRecords, { [recordId]: rows })
      var newLoadingRecords = Object.assign({}, self.state.loadingRecords, { [recordId]: false })
      self.setState({ signedRecords: newSignedRecords, loadingRecords: newLoadingRecords })
    }).catch(function(error) {
      message.error('Failed to load signed records')
      var newLoadingRecords = Object.assign({}, self.state.loadingRecords, { [recordId]: false })
      self.setState({ loadingRecords: newLoadingRecords })
    })
  }

  renderExpandedRow = (record) => {
    var isLoading = this.state.loadingRecords[record.id]
    var rows = this.state.signedRecords[record.id] || []

    if (isLoading) {
      return (
        <div style={{ padding: '12px 0', textAlign: 'center' }}>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />} />
          <span style={{ marginLeft: 8 }}>Loading signed records...</span>
        </div>
      )
    }

    if (rows.length === 0) {
      return (
        <div style={{ padding: '12px 0', color: '#999' }}>
          No signed records found for this RAMS record.
        </div>
      )
    }

    var signedColumns = [
      {
        title: 'Subcontractor',
        dataIndex: 'subcontractor_name',
        key: 'subcontractor_name',
      },
      {
        title: 'Status',
        key: 'status',
        width: 120,
        render: function(text, row) {
          if (row.status === 'expired') {
            if (row.signed) {
              return <Tag icon={<CheckCircleOutlined />} color="default">Signed (Expired)</Tag>
            }
            return <Tag icon={<ClockCircleOutlined />} color="default">Expired</Tag>
          }
          if (row.signed) {
            return <Tag icon={<CheckCircleOutlined />} color="success">Signed</Tag>
          }
          if (row.viewed) {
            return <Tag icon={<EyeOutlined />} color="processing">Viewed</Tag>
          }
          return <Tag icon={<ClockCircleOutlined />} color="warning">Pending</Tag>
        },
      },
      {
        title: 'Sent',
        dataIndex: 'sent_at',
        key: 'sent_at',
        render: function(text) {
          return text ? moment(text).format('DD/MM/YYYY HH:mm') : '-'
        },
      },
      {
        title: 'Signed At',
        dataIndex: 'signed_at',
        key: 'signed_at',
        render: function(text) {
          return text ? moment(text).format('DD/MM/YYYY HH:mm') : '-'
        },
      },
      {
        title: 'PDF',
        key: 'download',
        width: 70,
        render: function(text, row) {
          if (!row.signed) return null
          if (row.signed_pdf_url) {
            return (
              <Tooltip title="Download Signed PDF">
                <a href={row.signed_pdf_url} target="_blank" rel="noopener noreferrer">
                  <DownloadOutlined style={{ fontSize: 18, color: '#1890FF' }} />
                </a>
              </Tooltip>
            )
          }
          return (
            <Tooltip title="Signed PDF not yet available">
              <DownloadOutlined style={{ fontSize: 18, color: '#ccc', cursor: 'not-allowed' }} />
            </Tooltip>
          )
        },
      },
    ]

    const signedScroll = { x: signedColumns.reduce((total, column) => total + (column.width || 150), 0) };

    return (
      <Table
        dataSource={rows}
        rowKey="id"
        columns={signedColumns}
        pagination={false}
        size="small"
        style={{ margin: '12px 0 12px 20px' }}
        scroll={signedScroll}
      />
    )
  }

  render () {

    const {
      project,
      fetching,
      onClickRecord,
      onClickNew,
    } = this.props

    var self = this

    const columns = [

      {
        title: '',
        key: 'expand',
        width: 40,
        render: function(text, record) {
          var isExpanded = self.state.expandedRowKeys.indexOf(record.id) !== -1
          var total = (record.signed && record.signed.total) || 0
          if (total === 0) return null
          return (
            <Tooltip title={isExpanded ? 'Hide signed records' : 'Show signed records'}>
              <Button
                type="text"
                size="small"
                icon={isExpanded ? <MinusOutlined /> : <PlusOutlined />}
                onClick={function(e) { e.stopPropagation(); self.handleExpand(record.id) }}
              />
            </Tooltip>
          )
        },
      },

      {
        title: 'No.',
        key: 'id',
        sorter: false,
        width: 100,
        render: (text, record) => (
          <a onClick={() => onClickRecord(record.id)} role="presentation">
            {`RAMS ${record.id}`}
          </a>
        ),
      },

      {
        title: 'Status',
        key: 'status',
        width: 130,
        sorter: false,
        render: function(text, record) {
          var status = record.status || 'unapproved'
          if (status === 'approved') return <Tag color="success">Approved</Tag>
          if (status === 'awaiting_approval') return <Tag color="processing">Awaiting Approval</Tag>
          if (status === 'expired') return <Tag color="error">Expired</Tag>
          return <Tag color="default">Unapproved</Tag>
        },
      },

      {
        title: 'Contact',
        key: 'client_contact_id',
        sorter: false,
        render: (text, record) => record.client_contact && record.client_contact.full_name,
      },

      {
        title: ' ',
        key: 'notes',
        sorter: false,
        width: 35,
        render: (text, record) => record.notes && (
          <Popover
            title="Notes"
            trigger="hover"
            content={(
              <div style={{ maxWidth: 300 }}>
                {record.notes}
              </div>
            )}
            style={{ maxWidth: 300 }}
          >
            <InfoCircleOutlined style={{ color: '#1890FF', fontSize: 18 }} />
          </Popover>
        ),
        onCell: () => ({ style: { padding: 0 } }),
      },
      {
            title: 'Signed',
            key: 'signed',
            width: 100,
            sorter: false,
            render: (text, record) => (
                  <div className={styles.icon}>
                      <Popover content={record.signed.signedPeople} title="Signed">
                          {record.signed.signed}
                      </Popover>
                  </div>
            ),
      },
      {
            title: 'Awaiting signed',
            key: 'awaiting_signed',
            width: 100,
            sorter: false,
            render: (text, record) => (
              <div className={styles.icon}>
                  <Popover content={record.signed.notSignedPeople} title="Not signed">
                      {record.signed.notSigned}
                  </Popover>
              </div>
            ),
      },
      {
        title: 'Valid From',
        key: 'valid_from',
        width: 150,
        sorter: false,
        render: (text, record) => record.valid_from ? moment(record.valid_from).format('DD MMM YYYY') : '',
      },
      {
        title: 'Valid To',
        key: 'valid_to',
        width: 150,
        sorter: false,
        render: (text, record) => record.valid_to ? moment(record.valid_to).format('DD MMM YYYY') : '',
      },
      {
        title: 'Services',
        key: 'services',
        width: 150,
        sorter: false,
        render: (text, record) => (
          <ServiceTypeIcons keys={record.services} />
        ),
      },

      {
        title: 'Access Equipment',
        key: 'access_equipment',
        sorter: false,
        render: (text, record) => (
          <Tooltip title={record.access_equipment.join(', ')}>
            {`${take(record.access_equipment, 2).join(', ')} ${record.access_equipment.length > 2 ? '...' : ''}`}
          </Tooltip>
        ),
      },

      {
        title: 'Paints',
        key: 'paints',
        sorter: false,
        render: (text, record) => (
          <Tooltip title={record.paints.join(', ')}>
            {`${take(record.paints, 2).join(', ')} ${record.paints.length > 2 ? '...' : ''}`}
          </Tooltip>
        ),
      },

      // {
      //   title: 'PDF',
      //   key: 'merged_pdf',
      //   width: 70,
      //   sorter: false,
      //   render: (text, record) => record.merged_pdf_url && (
      //     <Tooltip title="Download RAMS PDF">
      //       <a href={record.merged_pdf_url} target="_blank" rel="noopener noreferrer">
      //         <DownloadOutlined style={{ fontSize: 18, color: '#1890FF' }} />
      //       </a>
      //     </Tooltip>
      //   ),
      // },

      {
        title: 'Sign-off',
        key: 'signoff_sheet',
        width: 80,
        sorter: false,
        render: (text, record) => {
          var loading = self.state.downloadingSignOff[record.id]
          return (
            <Tooltip title={loading ? 'Downloading...' : 'Download sign-off sheet'}>
              <FileTextOutlined
                style={{ fontSize: 18, color: loading ? '#ccc' : '#52c41a', cursor: loading ? 'wait' : 'pointer' }}
                onClick={loading ? null : () => self.handleDownloadSignOff(record.id)}
              />
            </Tooltip>
          )
        },
      },

      {
        title: 'Revision',
        key: 'revision_sheet',
        width: 80,
        sorter: false,
        render: (text, record) => {
          var loading = self.state.downloadingRevision[record.id]
          return (
            <Tooltip title={loading ? 'Generating...' : 'Download revision sheet'}>
              <FileTextOutlined
                style={{ fontSize: 18, color: loading ? '#ccc' : '#fa8c16', cursor: loading ? 'wait' : 'pointer' }}
                onClick={loading ? null : () => self.handleDownloadRevision(record.id)}
              />
            </Tooltip>
          )
        },
      },

      {
        title: 'Full Doc',
        key: 'full_document',
        width: 80,
        sorter: false,
        render: (text, record) => {
          var loading = self.state.downloadingFull[record.id]
          return (
            <Tooltip title={loading ? 'Generating...' : 'Download full document (+sign off +revision)'}>
              <FilePdfOutlined
                style={{ fontSize: 18, color: loading ? '#ccc' : '#722ed1', cursor: loading ? 'wait' : 'pointer' }}
                onClick={loading ? null : () => self.handleDownloadFull(record.id)}
              />
            </Tooltip>
          )
        },
      },

    ]

    const scroll = { x: columns.reduce((total, column) => total + (column.width || 150), 0) };

    const ramsRecords = reverse(sortBy(project.rams_records, ['id']))

    return (

      <div>

        <div style={{ marginBottom: 15 }}>

          <Button type="primary" onClick={onClickNew}>
            New RAMS
          </Button>

        </div>

        <Table
          dataSource={ramsRecords}
          rowKey={record => record.id}
          columns={columns}
          loading={fetching}
          scroll={scroll}
          expandable={{
            expandedRowKeys: this.state.expandedRowKeys,
            expandedRowRender: this.renderExpandedRow,
            expandIconColumnIndex: -1,
            expandRowByClick: false,
          }}
        />

      </div>

    )
  }
}
